<template>
  <v-container fluid class="pa-0">
    <breadcrumbs-banner
      :bannerTitle="$t('header.pathologiesMoreConsulted')"
    ></breadcrumbs-banner>
    <v-container class="py-lg-16 pa-10 pa-sm-14 px-lg-3">
      <v-row class="my-lg-16">
        <v-col cols="12" lg="3">
          <v-row
            v-for="(pathologyItem, index) in pathologies"
            :key="index"
            class="mx-0 py-lg-3 justify-center justify-lg-start"
            :class="{ 'py-4 py-lg-0': !pathologySelected }"
          >
            <v-btn
              class="elevation-0 text-left text-navy font-weight-bold "
              v-if="!pathologySelected || screen > 1264"
              :class="{
                'background-green-light text-white':
                pathologyItem.slug === pathologySelected.slug && screen > 1264,
                transparent: pathologyItem.slug !== pathologySelected.slug && screen > 1264,
              }"
              @click="changePathology(pathologyItem)"
            >
              {{ pathologyItem.name }}
            </v-btn></v-row
          >
        </v-col>
        <v-col cols="12" lg="9" v-if="pathologySelected">
          <v-row class="justify-end d-lg-none">
            <v-btn
              class="
                mx-lg-auto
                elevation-0
                rounded-xl
                background-green-light
                text-white text-capitalize text-lg-h6
                font-weight-bold
              "
              outlined
              width="150"
              @click="$router.push({name: 'pathologiesMoreConsulted'})"
            >
              {{ $t("areas.goBack") }}</v-btn
            >
          </v-row>
          <v-row>
            <v-col cols="12" v-if="pathologySelected">
              <h3
                class="text-lg-h3 text-h5 text-navy font-weight-bold"
                v-html="pathologySelected.name"
              ></h3>
              <hr class="hr-first" />
              <p
                class="text-navy font-weight-light mt-5"
                v-html="pathologySelected.description"
              ></p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <schedule-your-appointment></schedule-your-appointment>
    <featured-articles class="px-5 px-sm-10 px-lg-0"></featured-articles>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import FeaturedArticles from "../../../components/featuredArticles.vue";
import scheduleYourAppointment from "../../../components/scheduleYourAppointment.vue";
import Pathology from '../../../services/pathology';

export default {
 
  components: { scheduleYourAppointment, FeaturedArticles },

  name: "pathologies",


  async created() {
    this.pathologies = await Pathology.getPathologies();
    this.pathologies.sort((a, b) => (a.name > b.name ? 1 : -1));
    if (this.screen > 1264) {
      this.pathologySelected = this.pathologies[0];
    }
  },
  data() {
    return {
      pathologies: [],
      pathologySelected: '',
    };
  },
  computed: {
    ...mapGetters("pathologies", ["getPathologies"]),
    screen() {
      return window.innerWidth;
    },
  },
  methods: {
    changePathology(item) {
      this.pathologySelected = item;
    }
  }

};
</script>
